import { createTheme } from '@mui/material/styles';
import { DrivablyTheme } from './drv';

export const ACVTheme = createTheme({ ...DrivablyTheme });
